import BaseComponent from "components/base-component"
import classNames from "classnames"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {Styling} from "models"
export default class ComponentsStylingsLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    styling: PropTypes.instanceOf(Styling).isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, styling, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--stylings--link", className)

    if (adminLayout) {
      return (
        <Link className={generatedClassName} to={this.to()} {...restProps}>
          {children || styling.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || styling.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, styling} = this.p

    if (adminLayout) {
      return Routes.adminStylingPath(styling.id())
    }

    return "#"
  }
}
